<template>
    <v-container h100 id="contact">
        <v-layout column>
            <v-flex :class=checkTitle text-xs-center >Contact {{this.$myApp.customer.name}}</v-flex>
            <v-flex :class=checkText text-xs-center>
                <div>
                    You can email us at <a class="nodec" :href="'mailto:'+this.$myApp.customer.email"> {{ this.$myApp.customer.email }}</a>
                </div>
            </v-flex>
            <v-flex :class=checkText text-xs-center mb:5>
                <div>
                    Or Phone us on  <a class="nodec" :href="'tel:'+this.$myApp.customer.phone"> {{ this.$myApp.customer.phone }}</a>
                </div>

            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'Contact',
        data() {
            return {
                checkTitle: this.$vuetify.breakpoint.mdAndUp ? 'display-2 my-5' : 'display-1 mt-5',
                checkText: this.$vuetify.breakpoint.mdAndUp ? 'headline mt-3' : 'title mt-2'
            };
        }
    };
</script>

<style scoped>
    a.nodec {text-decoration: none;}
</style>
